export enum MaritalStatusChoice {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  DIVORCED = 'DIVORCED',
}

export enum CivilityChoice {
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS',
}

export enum GenderChoice {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum PaymentMethodChoice {
  CASH = 'CASH',
  MOBILE_MONEY = 'MOBILE MONEY',
  TRANSFER = 'TRANSFER',
}

export enum CodeCnpsRegime {
  GENERAL = 1,
  AGRICOLE = 2,
  ENSEIGNEMENT_PRIVE = 3,
  DOMESTIQUE = 4,
}

export enum CodeGroup {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum ContractTypeChoice {
  CDD = 'CDD',
  CDI = 'CDI',
  FREELANCE = 'FREELANCE',
  TRIAL = 'TRIAL',
  INTERNSHIP = 'INTERNSHIP',
}

export enum StatusChoice {
  ONGOING = 'ONGOING',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
}

export enum CONTRACT_TERMINATION_PROCESS_STATUS {
  STAFF_SUSPENDED = 'STAFF_SUSPENDED',
  ADMIN_SUSPENDED = 'ADMIN_SUSPENDED',
}

export const GET_DESIGNATED_CONTRACT_TERMINATION_TEMPLATES: Map<
  CONTRACT_TERMINATION_PROCESS_STATUS,
  string | undefined
> = new Map([
  [
    CONTRACT_TERMINATION_PROCESS_STATUS.ADMIN_SUSPENDED,
    process.env['ADMIN_CONTRACT_TERMINATION_TEMPLATE_KEY'],
  ],
  [
    CONTRACT_TERMINATION_PROCESS_STATUS.STAFF_SUSPENDED,
    process.env['STAFF_CONTRACT_TERMINATION_TEMPLATE_KEY'],
  ],
]);

export enum RoleName {
  ADMIN = 'Admin',
  ACCOUNTANT = 'Accountant',
  STAFF = 'Staff',
}

export enum NotificationType {
  Within2Months = 'WITHIN_2_MONTHS',
  Within2Weeks = 'WITHIN_2_WEEKS',
  Within2Days = 'WITHIN_2_DAYS',
}

export enum InternalQueueMessageType {
  CREATE_OR_UPDATE_PAYSLIP = 'CREATE_OR_UPDATE_PAYSLIP',
  GENERATE_MAGNETIC_DIPE = 'GENERATE_MAGNETIC_DIPE',
  CREATE_OR_UPDATE_CNPS_DECLARATION = 'CREATE_OR_UPDATE_CNPS_DECLARATION',
  CREATE_CNPS_DECLARATION = 'CREATE_CNPS_DECLARATION',
  UPDATE_PAYSLIP = 'UPDATE_PAYSLIP',
  GENERATE_PAYSLIPS_PER_PAY_PERIOD = 'GENERATE_PAYSLIPS_PER_PAY_PERIOD',
  PRINT_ONE_PAYSLIP = 'PRINT_ONE_PAYSLIP',
  SEND_PAYSLIPS_PER_PAY_PERIOD = 'SEND_PAYSLIPS_PER_PAY_PERIOD',
  SEND_TIMESHEETS_PER_BILLING_PERIOD = 'SEND_TIMESHEETS_PER_BILLING_PERIOD',
  PRINT_TRANSACTIONS_EXCEL_PAYPERIOD = 'PRINT_TRANSACTIONS_EXCEL_PAYPERIOD',
  UPDATE_CONTRACT_PAYSLIPS = 'UPDATE_CONTRACT_PAYSLIPS',
  UPDATE_COMPANY_PAYSLIPS = 'UPDATE_COMPANY_PAYSLIPS',
  UPDATE_STAFF_PAYSLIPS = 'UPDATE_STAFF_PAYSLIPS',
  SEND_CONTRACT_TERMINATION_EMAIL = 'SEND_CONTRACT_TERMINATION_EMAIL',
}

export enum StepFunctionMessageType {
  GENERATE_ONE_PAYSLIP = 'GENERATE_ONE_PAYSLIP',
  LIST_CONTRACTS_FOR_PAYSLIPS_GENERATION = 'LIST_CONTRACTS_FOR_PAYSLIPS_GENERATION',
  END_OF_PAYSLIPS_GENERATION = 'END_OF_PAYSLIPS_GENERATION',
  CREATE_TRANSACTION = 'CREATE_TRANSACTION',
  GENERATE_CNPS_DECLARATION = 'GENERATE_CNPS_DECLARATION',
  PRINT_DIPE_TEXTE = 'PRINT_DIPE_TEXTE',
  PRINT_DIPE_EXCEL = 'PRINT_DIPE_EXCEL',
  PRINT_ANNUAL_DIPE_EXCEL = 'PRINT_ANNUAL_DIPE_EXCEL',
  LIST_PAYSLIPS_PER_PAY_PERIOD = 'LIST_PAYSLIPS_PER_PAY_PERIOD',
  SET_DEFAULT_PAYROLL_ELEMENTS = 'SET_DEFAULT_PAYROLL_ELEMENTS',
  SET_PAYROLL_ELEMENTS_FOR_COMPANY = 'SET_PAYROLL_ELEMENTS_FOR_COMPANY',
  UPDATE_PAYPERIOD_DETAILS = 'UPDATE_PAYPERIOD_DETAILS',
  CREATE_PAYROLL_SESSION = 'CREATE_PAYROLL_SESSION',
  SEND_NOTIFICATION_FOR_UNPAID_CNPS_DECLARATION = 'SEND_NOTIFICATION_FOR_UNPAID_CNPS_DECLARATION',
  LIST_UNPAID_DECLARATIONS = 'LIST_UNPAID_DECLARATIONS',
  CLOSE_PAYROLL_SESSION = 'CLOSE_PAYROLL_SESSION',
  CLOSE_PAYPERIOD_PROCESSOR = 'CLOSE_PAYPERIOD_PROCESSOR',
}

export enum InternalLambdaMessageType {
  GET_CONTRACTS = 'GET_CONTRACTS',
  UPDATE_CONTRACT = 'UPDATE_CONTRACT',
  LIST_ACCOUNTS_FOR_BANK_TRANSACTIONS_IMPORT = 'LIST_ACCOUNTS_FOR_BANK_TRANSACTIONS_IMPORT',
  LIST_ACCOUNTS_WITH_MISSED_CYCLE_COUNT = 'LIST_ACCOUNTS_WITH_MISSED_CYCLE_COUNT',
  MISSED_CYCLE_COUNT_NOTIFICATION = 'MISSED_CYCLE_COUNT_NOTIFICATION',
  EXTRACT_INVOICE_INFORMATION_FROM_DOCUMENT = 'EXTRACT_INVOICE_INFORMATION_FROM_DOCUMENT',
  CREATE_ACCOUNTING_BOOK = 'CREATE_ACCOUNTING_BOOK',
  IMPORT_STATEMENT_FROM_FILE = 'IMPORT_STATEMENT_FROM_FILE',
  GENERATE_STAFF_INVOICE_ATTACHMENT = 'GENERATE_STAFF_INVOICE_ATTACHMENT',
  APPLY_RULES_ON_TRANSACTIONS = 'APPLY_RULES_ON_TRANSACTIONS',
  GET_TRANSACTIONS_PAGINATION = 'GET_TRANSACTIONS_PAGINATION',
  LIST_COMPANY_WITH_TRANSACTION_RULES = 'LIST_COMPANY_WITH_TRANSACTION_RULES',
  START_APPLY_RULE_ON_UNJUSTIFIED_TRANSACTIONS_STATE_MACHINE = 'START_APPLY_RULE_ON_UNJUSTIFIED_TRANSACTIONS_STATE_MACHINE',
  PROCESS_UPLOADED_INVOICE = 'PROCESS_UPLOADED_INVOICE',
  LIST_COMPANIES_FOR_TRANSACTION_INVOICE_MATCHING = 'LIST_COMPANIES_FOR_TRANSACTION_INVOICE_MATCHING',
  TRANSACTION_INVOICE_MATCHING = 'TRANSACTION_INVOICE_MATCHING',
  LIST_TAX_DECLARATIONS = 'LIST_TAX_DECLARATIONS',
  GET_TAX_DECLARATION_PAYLOAD = 'GET_TAX_DECLARATION_PAYLOAD',
}

export enum EmailQueueMessageType {
  SEND_CONTRACT_TERMINATION_EMAIL = 'SEND_CONTRACT_TERMINATION_EMAIL',
  SEND_STAFF_REQUEST_PROCESS_EMAILS = 'SEND_STAFF_REQUEST_PROCESS_EMAILS',
  SEND_STAFF_INVITATIION_EMAILS = 'SEND_STAFF_INVITATIION_EMAILS',
  SEND_PAYSLIP_NOTIFICATION_EMAIL = 'SEND_PAYSLIP_NOTIFICATION_EMAIL',
  SEND_TIMESHEETS_NOTIFICATION_EMAIL = 'SEND_TIMESHEETS_NOTIFICATION_EMAIL',
  VALIDATION_PAYSLIP_EMAIL_TEMPLATE_KEY = 'VALIDATION_PAYSLIP_EMAIL_TEMPLATE_KEY',
  SEND_CONTACT_FORM_EMAIL = 'SEND_CONTACT_FORM_EMAIL',
}

export enum TAX_TYPE {
  IRPP = 'Irpp',
  CAC_IRPP = 'CAC_IRPP',
  CFC = 'CFC',
  AUDIO_VISUAL_FEE = 'AudioVisualFee',
  EMPLOYE_CFC = 'EmployeeCFC',
  LOCAL_DEVELOPMENT_TAX = 'LocalDvpTax',
  FNE = 'Fne',
}

export enum OVER_TIME_TYPE {
  OVER_TIME_120 = 'overTime120',
  OVER_TIME_130 = 'overTime130',
  OVER_TIME_140 = 'overTime140',
  OVER_TIME_150 = 'overTime150',
  OVER_TIME_200 = 'overTime200',
  OVER_TIME_60 = 'overTime60',
  OVER_TIME_45 = 'overTime45',
  NIGHT_ALLOWANCE = 'nightAllowance',
}

export enum OvertimeEnum {
  OVERTIME_120 = 'overTime120',
  OVERTIME_130 = 'overTime130',
  OVERTIME_140 = 'overTime140',
  OVERTIME_150 = 'overTime150',
  OVERTIME_200 = 'overTime200',
  OVERTIME_145 = 'overTime145',
  OVERTIME_160 = 'overTime160',
}

export enum OVERTIME_TYPE {
  OVERTIME_SIMPLE = 'OVERTIME SIMPLE',
  NIGHT_OVERTIME = 'NIGHT OVERTIME',
  HOLIDAYS_OVERTIME = 'HOLIDAYS OVERTIME',
}

export const NAME_OVERTIME: Map<OvertimeEnum, string> = new Map([
  [OvertimeEnum.OVERTIME_120, 'OverTime 120'],
  [OvertimeEnum.OVERTIME_130, 'OverTime 130'],
  [OvertimeEnum.OVERTIME_140, 'OverTime 140'],
  [OvertimeEnum.OVERTIME_150, 'OverTime 150'],
  [OvertimeEnum.OVERTIME_200, 'OverTime 200'],
  [OvertimeEnum.OVERTIME_160, 'OverTime 160'],
  [OvertimeEnum.OVERTIME_145, 'OverTime 145'],
]);

export enum ContextScope {
  PREVIEW = 'PREVIEW',
  DETAILS = 'DETAILS',
  ALL = 'ALL',
  MIN = 'MIN',
  PAYROLL_VARIABLES = 'PAYROLL_VARIABLES',
}

export enum StateUser {
  UNCONFIRMED = 'UNCONFIRMED',
  CONFIRMED = 'CONFIRMED',
  INVITED = 'INVITED',
  SUSPENDED = 'SUSPENDED',
  EXPIRED = 'EXPIRED',
  DELETED = 'DELETED',
}

export const MAP_STATE_USER: Map<string, StateUser> = new Map([
  ['unconfirmed', StateUser.UNCONFIRMED],
  ['confirmed', StateUser.CONFIRMED],
  ['invited', StateUser.INVITED],
  ['suspended', StateUser.SUSPENDED],
  ['expired', StateUser.EXPIRED],
  ['deleted', StateUser.DELETED],
]);

export enum PROFILE_TYPE {
  USER = 'USER',
  CABINET = 'CABINET',
}
export enum SALARY_ELEMENTS_EMUM {
  SALARY = 'salary',
  EXTRA_PAY = 'extraPay',
}

export enum SALARY_CHARGES_EMUM {
  FAMILY_ALLOWANCES = 'familyAllowances',
  OLD_AGE_BRANCH_PATRON = 'oldAgeBranchPatron',
  OLD_AGE_BRANCH = 'oldAgeBranch',
  WORK_ACCIDENT = 'workAccident',
}

export enum NET_SALARY_ENUM {
  NET_SALARY = 'netSalary',
}

export const TRANSPORT_ALLOWANCE = 25000;
export const HOUSING_RATE = 20;
export const CAPPED_CONTRIBUTE_SALARY = 750000;
export const DIPE_NUMBER = '00000';
export const LOCAL_DEVELOPMENT_TAX: Map<string, number> = new Map([
  ['62000-75000', 3000 / 12],
  ['75001-100000', 6000 / 12],
  ['100001-125000', 9000 / 12],
  ['125001-150000', 12000 / 12],
  ['150001-200000', 15000 / 12],
  ['200001-250000', 18000 / 12],
  ['250001-300000', 24000 / 12],
  ['300001-500000', 27000 / 12],
]);

export class Constants {
  static status = class status {
    static readonly EN_COUR_DE_VALIDATION = 'En cours de validation';
    static readonly VALIDE = 'Validé';
    static readonly EN_COUR_DE_LECTURE = 'En cours de lecture';
  };
  static accountingJournal = class AccountingJournal {
    static readonly AUTRES_ACHATS = 'AUT';
  };
  static account = class Account {
    static readonly SUPPLIER = 401100;
    static readonly TVA = 4452;
  };
  static TRANSPORT_ALLOWANCE_NAME = 'Indemnité de transport';
  static HOUSING_ALLOWANCE_NAME = 'Indemnité de logement';
  static PAID_LEAVE_ALLOWANCE_NAME = 'indemnité de congé';
  static MONTHLY_PAID_LEAVE_GAINED = 1.5;
  static NORMAL_WEEKLY_TIME = 40;

  static paySlipConstants = class CONSTANTS {};
}

export enum CONTENT_TYPE {
  PDF = 'application/pdf',
  TEXT = 'text/plain',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  PNG = 'image/png',
  XLSX = 'application/xlsx',
  CSV = 'text/csv',
}

export enum FILE_FORMAT {
  PDF = 'pdf',
  TEXT = 'txt',
  JPEG = 'jpeg',
  JPG = 'jpg',
  PNG = 'png',
  XLSX = 'xlsx',
  CSV = 'csv',
}

export const MAP_CONTENT_TYPE_FILE_FORMAT: Record<CONTENT_TYPE, FILE_FORMAT> = {
  [CONTENT_TYPE.PDF]: FILE_FORMAT.PDF,
  [CONTENT_TYPE.TEXT]: FILE_FORMAT.TEXT,
  [CONTENT_TYPE.JPEG]: FILE_FORMAT.JPEG,
  [CONTENT_TYPE.JPG]: FILE_FORMAT.JPG,
  [CONTENT_TYPE.PNG]: FILE_FORMAT.PNG,
  [CONTENT_TYPE.XLSX]: FILE_FORMAT.XLSX,
  [CONTENT_TYPE.CSV]: FILE_FORMAT.CSV,
};

export enum ORGANIZATION_USER_STATUS {
  PENDING = 'En attente',
  ACTIVE = 'Actif',
  CANCELED = 'Annulé',
  DESACTIVATE = 'Désactivé',
}

export enum ORGANIZATION_TAXATION_REGIME {
  REAL = 'Réel',
  SIMPLIFIED = 'Simplifié',
}

export enum S3Folders {
  CNPS = 'cnps',
  PAYSLIPS = 'payslips',
  TEMPORARY = 'temporary',
}

export enum DOCUMENT_TYPE {
  INVOICE = 'INVOICE',
  STATEMENT = 'STATEMENT',
  PAYSLIP = 'PAYSLIP',
  FISCAL = 'FISCAL',
}

export enum S3FoldersByDocumentType {
  INVOICE = 'invoices',
  PAYSLIP = 'payslips',
  STATEMENT = 'statements',
}

export const MONTH_OF_DECEMBER = 11;
export const WORK_TIME_PER_DAY = new Map<string, number>([['_CCC', 2]]);

export const CLOUD_APP_ENV = [
  'dev1',
  'dev2',
  'dev3',
  'dev4',
  'release',
  'staging',
  'production',
];

export enum BOOLEAN_ENUM {
  ONE = '1',
  ZERO = '0',
  TRUE = 'true',
  FALSE = 'false',
}

export const SortOrderEnum = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const TVA_RATE = 0.1925;

export enum StaffInvoiceStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  NOT_SENT = 'NOT_SENT',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
}

export enum BillingItemUnit {
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
export const BILLING_ITEM_UNIT_LABELS = {
  en: {
    [BillingItemUnit.HOUR]: 'Hour',
    [BillingItemUnit.DAY]: 'Day',
    [BillingItemUnit.WEEK]: 'Week',
    [BillingItemUnit.MONTH]: 'Month',
  },
  fr: {
    [BillingItemUnit.HOUR]: 'Heure',
    [BillingItemUnit.DAY]: 'Jour',
    [BillingItemUnit.WEEK]: 'Semaine',
    [BillingItemUnit.MONTH]: 'Mois',
  },
};

export const STAFF_INVOICE_TAX_RATE_FACTOR = 0.11; //%11
export const STAFF_INVOICE_TAX_RATE = STAFF_INVOICE_TAX_RATE_FACTOR * 100;

export enum MunicipalityEnum {
  MUNICIPALITY_123 = '123',
  'ABONG-BANG' = 'ABONG-BANG',
  'AFANLOUM' = 'AFANLOUM',
  'AKO' = 'AKO',
  'AKOEMAN' = 'AKOEMAN',
  'AKOM II' = 'AKOM II',
  'AKONO' = 'AKONO',
  'AKONOLINGA' = 'AKONOLINGA',
  'AKWAYA' = 'AKWAYA',
  'ALOU' = 'ALOU',
  'AMBAM' = 'AMBAM',
  'ANDEK' = 'ANDEK',
  'ANGOSSAS' = 'ANGOSSAS',
  'AWAE' = 'AWAE',
  'AYOS' = 'AYOS',
  'BABADJOU' = 'BABADJOU',
  'BABESSI' = 'BABESSI',
  'BAFANG' = 'BAFANG',
  'BAFIA' = 'BAFIA',
  'BAFOUSSAM Ier' = 'BAFOUSSAM Ier',
  'BAFOUSSAM IIe' = 'BAFOUSSAM IIe',
  'BAFOUSSAM IIIe' = 'BAFOUSSAM IIIe',
  'BAFUT' = 'BAFUT',
  'BAHAM' = 'BAHAM',
  'BAKOU' = 'BAKOU',
  'BALI' = 'BALI',
  'BALIKUMBAT' = 'BALIKUMBAT',
  'BAMENDA Ier' = 'BAMENDA Ier',
  'BAMENDA IIe' = 'BAMENDA IIe',
  'BAMENDA IIIe' = 'BAMENDA IIIe',
  'BAMENDJOU' = 'BAMENDJOU',
  'BAMUSSO' = 'BAMUSSO',
  'BANA' = 'BANA',
  'BANDJA' = 'BANDJA',
  'BANDJOUN' = 'BANDJOUN',
  'BANGANGTE' = 'BANGANGTE',
  'BANGEM' = 'BANGEM',
  'BANGOU' = 'BANGOU',
  'BANGOURAIN' = 'BANGOURAIN',
  'BANKA' = 'BANKA',
  'BANKIM' = 'BANKIM',
  'BANWA' = 'BANWA',
  'BANYO' = 'BANYO',
  'BARE-BAKEM' = 'BARE-BAKEM',
  'BASHEO' = 'BASHEO',
  'BASSAMBA' = 'BASSAMBA',
  'BATCHAM' = 'BATCHAM',
  'BATCHENGA' = 'BATCHENGA',
  'BATIBO' = 'BATIBO',
  'BATIE' = 'BATIE',
  'BATOURI' = 'BATOURI',
  'BAYANGAM' = 'BAYANGAM',
  'BAZOU' = 'BAZOU',
  'BEBESSI' = 'BEBESSI',
  'BEKA' = 'BEKA',
  'BELABO' = 'BELABO',
  'BELEL' = 'BELEL',
  'BELO' = 'BELO',
  'BENAKUMA' = 'BENAKUMA',
  'BENGBIS' = 'BENGBIS',
  'BERTOUA Ier' = 'BERTOUA Ier',
  'BERTOUA IIe' = 'BERTOUA IIe',
  'BETARE OYA' = 'BETARE OYA',
  'BIBEMI' = 'BIBEMI',
  'BIBEY' = 'BIBEY',
  'BIKOK' = 'BIKOK',
  'BIPINDI' = 'BIPINDI',
  'BIWONG BANE' = 'BIWONG BANE',
  'BIWONG-BULU' = 'BIWONG-BULU',
  'BIYOUHA' = 'BIYOUHA',
  'BLANGOUA' = 'BLANGOUA',
  'BOGO' = 'BOGO',
  'BOKITO' = 'BOKITO',
  'BONALEA' = 'BONALEA',
  'BONDJOCK' = 'BONDJOCK',
  'BOT MAKAK' = 'BOT MAKAK',
  'BOURRHA' = 'BOURRHA',
  'BUEA' = 'BUEA',
  'CAMPO' = 'CAMPO',
  'DARAK' = 'DARAK',
  'DARGALA' = 'DARGALA',
  'DATCHEKA' = 'DATCHEKA',
  'DEMBO' = 'DEMBO',
  'DEMDENG' = 'DEMDENG',
  'DEUK' = 'DEUK',
  'DIANG' = 'DIANG',
  'DIBAMBA' = 'DIBAMBA',
  'DIBANG' = 'DIBANG',
  'DIBOMBARI' = 'DIBOMBARI',
  'DIKOME-BALUE' = 'DIKOME-BALUE',
  'DIMAKO' = 'DIMAKO',
  'DIR' = 'DIR',
  'DIZANGUE' = 'DIZANGUE',
  'DJOHONG' = 'DJOHONG',
  'DJOUM' = 'DJOUM',
  'DOUALA Ier' = 'DOUALA Ier',
  'DOUALA II' = 'DOUALA II',
  'DOUALA III' = 'DOUALA III',
  'DOUALA IV' = 'DOUALA IV',
  'DOUALA V' = 'DOUALA V',
  'DOUALA VI' = 'DOUALA VI',
  'DOUMAINTANG' = 'DOUMAINTANG',
  'DOUME' = 'DOUME',
  'DSCHANG' = 'DSCHANG',
  'DZENG' = 'DZENG',
  'DZIGUILAO' = 'DZIGUILAO',
  'EBEBDA' = 'EBEBDA',
  'EBOLOWA Ier' = 'EBOLOWA Ier',
  'EBOLOWA II' = 'EBOLOWA II',
  'EBONE' = 'EBONE',
  'EDEA Ier' = 'EDEA Ier',
  'EDEA II' = 'EDEA II',
  'EDZENDOUAN' = 'EDZENDOUAN',
  'EFOULAN' = 'EFOULAN',
  'EKONDO-TITI' = 'EKONDO-TITI',
  'ELIG MFOMO' = 'ELIG MFOMO',
  'ENDOM' = 'ENDOM',
  'ESEKA' = 'ESEKA',
  'ESSE' = 'ESSE',
  'EVODOULA' = 'EVODOULA',
  'EYUMOJOCK' = 'EYUMOJOCK',
  'FIGUIL' = 'FIGUIL',
  'FOKOUE' = 'FOKOUE',
  'FONFUKA' = 'FONFUKA',
  'FONGO-TONGO' = 'FONGO-TONGO',
  'FOTOKOL' = 'FOTOKOL',
  'FOUMBAN' = 'FOUMBAN',
  'FOUMBOT' = 'FOUMBOT',
  'FUNDONG' = 'FUNDONG',
  'FURU AWA' = 'FURU AWA',
  'GALIM' = 'GALIM',
  'GALIM TIGNERE' = 'GALIM TIGNERE',
  'GARI-GOMBO' = 'GARI-GOMBO',
  'GAROUA Ier' = 'GAROUA Ier',
  'GAROUA IIe' = 'GAROUA IIe',
  'GAROUA IIIe' = 'GAROUA IIIe',
  'GAROUA-BOULAÏ' = 'GAROUA-BOULAÏ',
  'GASHIGA' = 'GASHIGA',
  'GAZAWA' = 'GAZAWA',
  'GOBO' = 'GOBO',
  'GOULFEY' = 'GOULFEY',
  'GUEME' = 'GUEME',
  'GUERE' = 'GUERE',
  'GUIDER' = 'GUIDER',
  'GUIDIGUIS' = 'GUIDIGUIS',
  'HILE ALIFA' = 'HILE ALIFA',
  'HINA' = 'HINA',
  'IDA-BATO' = 'IDA-BATO',
  'IDENAU(WEST-COAST)' = 'IDENAU(WEST-COAST)',
  'ISANGUELE' = 'ISANGUELE',
  'JAKIRI' = 'JAKIRI',
  'KAELE' = 'KAELE',
  'KAÏ-KAÏ' = 'KAÏ-KAÏ',
  'KALFOU' = 'KALFOU',
  'KAR HAY' = 'KAR HAY',
  'KEKEM' = 'KEKEM',
  'KENTZOU' = 'KENTZOU',
  'KETTE' = 'KETTE',
  'KIIKI' = 'KIIKI',
  'KOLOFATA' = 'KOLOFATA',
  'KOMBO ABEDIMO' = 'KOMBO ABEDIMO',
  'KOMBO ITINDI' = 'KOMBO ITINDI',
  'KONTCHA' = 'KONTCHA',
  'KON-YAMBETA' = 'KON-YAMBETA',
  'KONYE' = 'KONYE',
  'KOUOPTAMO' = 'KOUOPTAMO',
  'KOUSSERI' = 'KOUSSERI',
  'KOUTABA' = 'KOUTABA',
  'KOZA' = 'KOZA',
  'KRIBI Ier' = 'KRIBI Ier',
  'KRIBI IIe' = 'KRIBI IIe',
  'KUMBA Ier' = 'KUMBA Ier',
  'KUMBA IIe' = 'KUMBA IIe',
  'KUMBA IIIe' = 'KUMBA IIIe',
  'KUMBO' = 'KUMBO',
  'KYE-OSSI' = 'KYE-OSSI',
  'LAGDO' = 'LAGDO',
  'LEMBE YEZOUM' = 'LEMBE YEZOUM',
  'LIMBE Ier' = 'LIMBE Ier',
  'LIMBE IIe' = 'LIMBE IIe',
  'LIMBE IIIe' = 'LIMBE IIIe',
  'LOBO' = 'LOBO',
  'LOGONE BIRNI' = 'LOGONE BIRNI',
  'LOKOUNDJE' = 'LOKOUNDJE',
  'LOLODORF' = 'LOLODORF',
  'LOMIE' = 'LOMIE',
  'LOUM' = 'LOUM',
  "MA'AN" = "MA'AN",
  'MADINGRING' = 'MADINGRING',
  'MAGA' = 'MAGA',
  'MAGBA' = 'MAGBA',
  'MAKAK' = 'MAKAK',
  'MAKARY' = 'MAKARY',
  'MAKENENE' = 'MAKENENE',
  'MALANTOUEN' = 'MALANTOUEN',
  'MAMFE' = 'MAMFE',
  'MANDJOU' = 'MANDJOU',
  'MANJO' = 'MANJO',
  'MAROUA Ier' = 'MAROUA Ier',
  'MAROUA IIe' = 'MAROUA IIe',
  'MAROUA IIIe' = 'MAROUA IIIe',
  'MARTAP' = 'MARTAP',
  'MASSANGAM' = 'MASSANGAM',
  'MASSOCK SONGLOULOU' = 'MASSOCK SONGLOULOU',
  'MATOMB' = 'MATOMB',
  'MAYO BALEO' = 'MAYO BALEO',
  'MAYO DARLE' = 'MAYO DARLE',
  'MAYO HOURNA' = 'MAYO HOURNA',
  'MAYO OULO' = 'MAYO OULO',
  'MBALMAYO' = 'MBALMAYO',
  'MBANDJOCK' = 'MBANDJOCK',
  'MBANG' = 'MBANG',
  'MBANGA' = 'MBANGA',
  'MBANGASSINA' = 'MBANGASSINA',
  'MBANKOMO' = 'MBANKOMO',
  'MBE' = 'MBE',
  'MBENGWI' = 'MBENGWI',
  'MBIAME' = 'MBIAME',
  'MBOMA' = 'MBOMA',
  'MBONGUE' = 'MBONGUE',
  'MBOUDA' = 'MBOUDA',
  'MEIGANGA' = 'MEIGANGA',
  'MELONG' = 'MELONG',
  'MENGANG' = 'MENGANG',
  'MENGONG' = 'MENGONG',
  'MENGUEME' = 'MENGUEME',
  'MENJI(FONTEM)' = 'MENJI(FONTEM)',
  'MERI' = 'MERI',
  'MESSAMENA' = 'MESSAMENA',
  'MESSOK' = 'MESSOK',
  'MESSONDO' = 'MESSONDO',
  'MEYO MESSI' = 'MEYO MESSI',
  'MEYOMESSALA' = 'MEYOMESSALA',
  'MFOU' = 'MFOU',
  'MINDIF' = 'MINDIF',
  'MINDOUROU' = 'MINDOUROU',
  'MINTA' = 'MINTA',
  'MINTOM' = 'MINTOM',
  'MISAJE' = 'MISAJE',
  'MOGODE' = 'MOGODE',
  'MOKOLO' = 'MOKOLO',
  'MOLOUNDOU' = 'MOLOUNDOU',
  'MOMBO' = 'MOMBO',
  'MONATELE' = 'MONATELE',
  'MORA' = 'MORA',
  'MOUANKO' = 'MOUANKO',
  'MOULVOUDAYE' = 'MOULVOUDAYE',
  'MOUTOURWA' = 'MOUTOURWA',
  'MOZOGO' = 'MOZOGO',
  'MUNDEMBA' = 'MUNDEMBA',
  'MUYUKA' = 'MUYUKA',
  'MVANGAN' = 'MVANGAN',
  'MVENGUE' = 'MVENGUE',
  'NANGA-EBOKO' = 'NANGA-EBOKO',
  'NDELELE' = 'NDELELE',
  'NDIKINIMIKI' = 'NDIKINIMIKI',
  'NDOBIAN' = 'NDOBIAN',
  'NDOM' = 'NDOM',
  'NDOP' = 'NDOP',
  'NDOUKOULA' = 'NDOUKOULA',
  'NDU' = 'NDU',
  'NGAMBE' = 'NGAMBE',
  'NGAMBE TIKAR' = 'NGAMBE TIKAR',
  'NGANHA' = 'NGANHA',
  'NGAOUI' = 'NGAOUI',
  'NGAOUNDAL' = 'NGAOUNDAL',
  'NGAOUNDERE Ier' = 'NGAOUNDERE Ier',
  'NGAOUNDERE IIe' = 'NGAOUNDERE IIe',
  'NGAOUNDERE IIIe' = 'NGAOUNDERE IIIe',
  'NGOG-MAPUBI' = 'NGOG-MAPUBI',
  'NGOMEZAP' = 'NGOMEZAP',
  'NGONG' = 'NGONG',
  'NGORO' = 'NGORO',
  'NGOULEMAKONG' = 'NGOULEMAKONG',
  'NGOUMOU' = 'NGOUMOU',
  'NGOURA' = 'NGOURA',
  'NGOYLA' = 'NGOYLA',
  'NGUELEBOK' = 'NGUELEBOK',
  'NGUELEMEDOUKA' = 'NGUELEMEDOUKA',
  'NGUI BASSAL' = 'NGUI BASSAL',
  'NGUTI' = 'NGUTI',
  'NGWEI' = 'NGWEI',
  'NIETE' = 'NIETE',
  'NITOUKOU' = 'NITOUKOU',
  'NJIKWA' = 'NJIKWA',
  'NJIMON' = 'NJIMON',
  'NJINIKOM' = 'NJINIKOM',
  'NJOMBE-PENJA' = 'NJOMBE-PENJA',
  'NKAMBE' = 'NKAMBE',
  'NKOLAFAMBA' = 'NKOLAFAMBA',
  'NKOLMETET' = 'NKOLMETET',
  'NKONDJOCK' = 'NKONDJOCK',
  'NKONG ZEM' = 'NKONG ZEM',
  'NKONGSAMBA Ier' = 'NKONGSAMBA Ier',
  'NKONGSAMBA IIe' = 'NKONGSAMBA IIe',
  'NKONGSAMBA IIIe' = 'NKONGSAMBA IIIe',
  'NKOR' = 'NKOR',
  'NKOTENG' = 'NKOTENG',
  'NKUM' = 'NKUM',
  'NSEM' = 'NSEM',
  'NTUI' = 'NTUI',
  'NWA' = 'NWA',
  'NYAKOKOMBO' = 'NYAKOKOMBO',
  'NYAMBAKA' = 'NYAMBAKA',
  'NYANON' = 'NYANON',
  'OBALA' = 'OBALA',
  'OKOLA' = 'OKOLA',
  'OKU' = 'OKU',
  'OLAMZE' = 'OLAMZE',
  'OLANGUINA' = 'OLANGUINA',
  'OMBESSA' = 'OMBESSA',
  'OULI' = 'OULI',
  'OVENG' = 'OVENG',
  'PENKA MICHEL' = 'PENKA MICHEL',
  'PETTE' = 'PETTE',
  'PITOA' = 'PITOA',
  'POLI' = 'POLI',
  'POUMA' = 'POUMA',
  'REY BOUBA' = 'REY BOUBA',
  'SA’A' = 'SA’A',
  'SALAPOUMBE' = 'SALAPOUMBE',
  'SANGMELIMA' = 'SANGMELIMA',
  'SANTA' = 'SANTA',
  'SANTCHOU' = 'SANTCHOU',
  'SOA' = 'SOA',
  'SOMALOMO' = 'SOMALOMO',
  'SOULEDE ROUA' = 'SOULEDE ROUA',
  'TCHATIBALI' = 'TCHATIBALI',
  'TCHOLIRE' = 'TCHOLIRE',
  'TIBATI' = 'TIBATI',
  'TIGNERE' = 'TIGNERE',
  'TIKO' = 'TIKO',
  'TINTO' = 'TINTO',
  'TOKO' = 'TOKO',
  'TOKOMBERE' = 'TOKOMBERE',
  'TOMBEL' = 'TOMBEL',
  'TONGA' = 'TONGA',
  'TOUBORO' = 'TOUBORO',
  'TOULOUM' = 'TOULOUM',
  'TOUROUA' = 'TOUROUA',
  'TUBAH' = 'TUBAH',
  'WABANE' = 'WABANE',
  'WAZA' = 'WAZA',
  'WIDIKUM BOFE' = 'WIDIKUM BOFE',
  'WINA' = 'WINA',
  'WUM' = 'WUM',
  'YABASSI' = 'YABASSI',
  'YAGOUA' = 'YAGOUA',
  'YAOUNDE I' = 'YAOUNDE I',
  'YAOUNDE II' = 'YAOUNDE II',
  'YAOUNDE III' = 'YAOUNDE III',
  'YAOUNDE IV' = 'YAOUNDE IV',
  'YAOUNDE V' = 'YAOUNDE V',
  'YAOUNDE VI' = 'YAOUNDE VI',
  'YAOUNDE VII' = 'YAOUNDE VII',
  'YINGUI' = 'YINGUI',
  'YOKADOUMA' = 'YOKADOUMA',
  'YOKO' = 'YOKO',
  'ZHOA' = 'ZHOA',
  'ZINA' = 'ZINA',
  'ZOETELE' = 'ZOETELE',
}

export const SUB_DIVISION_OPTIONS = [
  ...Object.values(MunicipalityEnum).map((item) => ({
    value: item,
    label: item,
  })),
];

export enum ActivityTypeEnum {
  INDUSTRIELLE_COMMERCIALE = 'INDUSTRIELLE_COMMERCIALE',
  AGRICOLE = 'AGRICOLE',
  ACTIVITE_MIXTE = 'ACTIVITE_MIXTE',
}

export const ACTIVITY_TYPE_OPTIONS = [
  {
    value: ActivityTypeEnum.INDUSTRIELLE_COMMERCIALE,
    label: 'dgi.activityType.industrialCommercial',
  },
  { value: ActivityTypeEnum.AGRICOLE, label: 'dgi.activityType.agricultural' },
  {
    value: ActivityTypeEnum.ACTIVITE_MIXTE,
    label: 'dgi.activityType.mixedActivity',
  },
];

export enum PaymentMethodEnum {
  MOBILE_TAX = 'MOBILE_TAX',
  VERSEMENT_ESPECES = 'VERSEMENT_ESPECES',
  VIREMENT_CLASSIQUE = 'VIREMENT_CLASSIQUE',
}

export const PAYMENT_METHOD_OPTIONS = [
  { value: PaymentMethodEnum.MOBILE_TAX, label: 'dgi.paymentMethod.mobileTax' },
  {
    value: PaymentMethodEnum.VERSEMENT_ESPECES,
    label: 'dgi.paymentMethod.cashDeposit',
  },
  {
    value: PaymentMethodEnum.VIREMENT_CLASSIQUE,
    label: 'dgi.paymentMethod.classicTransfer',
  },
];

export const PAYMENT_METHOD_MAP = {
  MOBILE_TAX: 'MOBILETAX',
  VERSEMENT_ESPECES: 'GUCE',
  VIREMENT_CLASSIQUE: 'VIREMENT_CLASSIQUE',
};

export const ACTIVITY_TYPE_MAP = {
  INDUSTRIELLE_COMMERCIALE: '1',
  AGRICOLE: '2',
  ACTIVITE_MIXTE: '3',
};

export enum PayrollSessionStatus {
  DRAFT = 'DRAFT',
  VALIDATED = 'VALIDATED',
  CLOSED = 'CLOSED',
}

export enum PayrollSessionClientStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}
